/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class IdFilters {
  /**
  * Matches if any string in this list equals `id`.
  */
  '_in'?: Array<string>;
  /**
  * Matches if no string in this list equals `id`.
  */
  'notIn'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_in",
      "baseName": "in",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "notIn",
      "baseName": "notIn",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return IdFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

